/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Next_WeekInputs */



/**
* | output |
* | --- |
* | "Next week" |
*
* @param {Agenda_Next_WeekInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_next_week = /** @type {((inputs?: Agenda_Next_WeekInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Next_WeekInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Volgende week")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Semaine suivante")
	return /** @type {LocalizedString} */ ("Next week")
});